type Props = {
  height?: number;
  width?: number;
  className?: string;
};

const Bulb = (props: Props) => {
  const { height = 32, width = 32, className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={height}
      height={width}
      fill="none"
      className={className}
      viewBox="0 0 32 32"
    >
      <path
        className="fill-brand"
        d="M15 4.256v-1.59c0-.283.096-.52.288-.712A.968.968 0 0 1 16 1.667c.284 0 .521.095.713.287.191.192.287.43.287.712v1.59c0 .284-.096.521-.288.713a.968.968 0 0 1-.712.287.967.967 0 0 1-.713-.287.968.968 0 0 1-.287-.713ZM29.333 17h-1.59a.967.967 0 0 1-.712-.288.968.968 0 0 1-.287-.713c0-.283.096-.52.287-.712a.968.968 0 0 1 .713-.287h1.59c.283 0 .52.096.712.287.192.192.287.43.287.713a.967.967 0 0 1-.287.713.968.968 0 0 1-.713.287ZM4.257 17h-1.59a.967.967 0 0 1-.713-.288.968.968 0 0 1-.287-.713c0-.283.096-.52.287-.712A.968.968 0 0 1 2.667 15h1.59c.283 0 .52.096.712.287.192.192.287.43.287.713a.967.967 0 0 1-.287.713.968.968 0 0 1-.712.287Zm21.846-9.677-.724.723a.954.954 0 0 1-.685.283.969.969 0 0 1-.722-.306.978.978 0 0 1-.298-.69.976.976 0 0 1 .28-.713l.744-.743a.932.932 0 0 1 .696-.304.976.976 0 0 1 .73.304.955.955 0 0 1 .3.723 1.03 1.03 0 0 1-.321.723ZM6.62 8.046l-.744-.744a.932.932 0 0 1-.304-.696.976.976 0 0 1 .304-.73.956.956 0 0 1 .723-.3c.275.008.516.114.723.321l.723.723a.954.954 0 0 1 .284.686.969.969 0 0 1-.307.722.978.978 0 0 1-.69.297.975.975 0 0 1-.712-.279ZM16.593 29.721a2.164 2.164 0 0 1-1.55-.622 2.23 2.23 0 0 1-.707-1.52h4.513a2.23 2.23 0 0 1-.708 1.52c-.433.415-.95.622-1.548.622Zm-4.445-3.784V24.16h8.89v1.777h-8.89Zm.183-3.418a8.62 8.62 0 0 1-2.949-3.026 7.983 7.983 0 0 1-1.086-4.085c0-2.31.806-4.27 2.416-5.88 1.611-1.611 3.571-2.417 5.88-2.417 2.31 0 4.27.806 5.881 2.416 1.61 1.61 2.416 3.571 2.416 5.88 0 1.479-.362 2.84-1.086 4.086a8.62 8.62 0 0 1-2.948 3.026H12.33Zm.528-1.778h7.467a6.575 6.575 0 0 0 2.06-2.34 6.379 6.379 0 0 0 .725-2.993c0-1.818-.632-3.358-1.896-4.623C19.95 9.521 18.41 8.89 16.593 8.89c-1.818 0-3.358.632-4.623 1.896-1.264 1.265-1.896 2.805-1.896 4.623 0 1.066.242 2.064.726 2.992a6.575 6.575 0 0 0 2.06 2.34Z"
      />
    </svg>
  );
};

export default Bulb;
